export const paymentConfigurationServerModel = config => {
    return {
        "Provider": config.provider,
        "TranzillaSettings": {
            "TranzillaTokenTerminalName": config.tranzillaTokenTerminalName || "",
            "TranzillaTerminalPassword": config.tranzillaTerminalPassword || "",
            "TranzillaTerminalName": config.tranzillaTerminalName || "",
            "TranzillaTerminal3dsName": config.tranzillaTerminal3dsName || "",
            "TranzillaPublicKey": config.tranzillaPublicKey || "",
            "TranzillaSecret": config.tranzillaSecret || "",
            "DcDisable": config.dcDisable || "",
        },
        "PaymeSettings": {
            "PayMeClientKey": config.payMeClientKey || "",
            "PaymeSellerId": config.paymeSellerId || "",
            "PaymeSecret": config.paymeSecret || "",
        },
        "StripeSettings": {
            "PublicStripeKey": config.publicStripeKey || "",
            "StripeKey": config.stripeKey || "",
        }
    }
}